define("settings/utils/plan-card/index", ["exports", "settings/utils/plan-card/tables"], function (_exports, _tables) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.buildPlanCard = buildPlanCard;
  0; //eaimeta@70e063a35619d71f0,"settings/utils/plan-card/tables"eaimeta@70e063a35619d71f
  function answeredSetFor(answers) {
    const {
      role,
      profiles,
      goal
    } = answers;
    return _tables.ANSWERED_SET[`${role !== undefined}_${profiles !== undefined}_${goal !== undefined}`];
  }
  function q1PhraseFor(role, profiles) {
    return profiles === '1' ? _tables.Q1_PHRASE_ONE_KEY[role] : _tables.Q1_PHRASE_KEY[role];
  }
  function calloutFor(tier, tag) {
    const copyKey = _tables.CALLOUT_COPY_KEY[tier][tag];

    // Unreachable: `CALLOUT_ORDER` only names tags its own tier offers, proved by the exhaustive
    // card-building tests, which construct a card for every reachable pair.
    if (copyKey === undefined) {
      throw new Error(`plan-card: no ${tag} callout copy defined for ${tier}`);
    }
    return {
      tag,
      tagKey: _tables.CALLOUT_TAG_KEY[tag],
      copyKey
    };
  }
  function alternativeFor(tier) {
    const alternative = _tables.ALTERNATIVE[tier];
    if (alternative === undefined) {
      return undefined;
    }
    return {
      // The next tier up, deliberately not the recommended one — the one message on the card whose
      // plan name is not the card's own.
      prompt: {
        key: _tables.ALTERNATIVE_PROMPT_KEY,
        params: {
          planName: _tables.PLAN_NAME_KEY[alternative.tier]
        }
      },
      conditionKey: alternative.conditionKey
    };
  }

  /**
   * Turns a recommended tier plus the plan recommendation answers into the card's content.
   *
   * Every field is a translation key or a key plus its params; the template resolves each with
   * `{{t}}` — the description with `htmlSafe`, since it carries `<b>` around its interpolations.
   *
   * The tier comes from `plan-score/`; nothing here recomputes it.
   */
  function buildPlanCard(tier, answers) {
    const {
      role,
      profiles,
      goal
    } = answers;
    const answeredSet = answeredSetFor(answers);
    const description = _tables.DESCRIPTION[answeredSet];
    const planName = _tables.PLAN_NAME_KEY[tier];
    const tags = _tables.CALLOUT_ORDER[tier][goal ?? 'not_answered'] ?? _tables.CALLOUT_ORDER[tier].not_answered;
    return {
      headline: {
        key: _tables.HEADLINE_KEY[answeredSet],
        params: {
          planName
        }
      },
      planNameKey: planName,
      description: {
        key: description.key,
        params: {
          q1Phrase: role === undefined ? undefined : q1PhraseFor(role, profiles),
          q2Range: profiles === undefined ? undefined : _tables.Q2_RANGE_KEY[profiles],
          q3Goal: goal === undefined ? undefined : _tables.Q3_GOAL_KEY[goal],
          valueSentence: description.usesValueSentence ? {
            key: _tables.VALUE_SENTENCE_KEY[tier],
            params: {
              planName
            }
          } : undefined
        }
      },
      offersLabel: {
        key: _tables.OFFERS_LABEL_KEY,
        params: {
          planName
        }
      },
      callouts: [calloutFor(tier, tags[0]), calloutFor(tier, tags[1]), calloutFor(tier, tags[2])],
      footnoteKey: _tables.FOOTNOTE_KEY[tier],
      alternative: alternativeFor(tier),
      cta: {
        key: _tables.CTA_KEY[tier],
        params: {
          planName
        }
      }
    };
  }
});